import { render } from "./ActivityTopAuthors.vue?vue&type=template&id=2f2c410a"
import script from "./ActivityTopAuthors.vue?vue&type=script&lang=js"
export * from "./ActivityTopAuthors.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__